import script from "./LanguegeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguegeSelector.vue?vue&type=script&setup=true&lang=js"

import "./LanguegeSelector.vue?vue&type=style&index=0&id=bbce914e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbce914e"]])

export default __exports__